const modal = {
  serchPar: {},
  ListData: [],
  roleData: [],
  newRole: false,
  exportloading: false,
  isSuperSupplier: false,
};

export default modal;
